var exports = {
  "x": "x04b3a21e--311229--button",
  "K": "x04b3a21e--311229--icon",
};

module.exports = exports;
